import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { FunctionalErrorItemRendering } from '@functional-errors/models';
import type { Observable } from 'rxjs';

import { FunctionalErrorsService } from './functional-errors.service';

@Pipe({
  name: 'functionalErrorItem',
  standalone: true,
})
export class FunctionalErrorItemPipe implements PipeTransform {
  transform(
    key: string | undefined
  ): Observable<FunctionalErrorItemRendering | undefined> {
    return this.functionalErrorService.getFunctionalError(key);
  }

  constructor(
    private readonly functionalErrorService: FunctionalErrorsService
  ) {}
}
